import { Callout } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

interface WireTransfersUKCalloutsProps {
  hasCrossCurrencySelection: boolean;
  canApprove: boolean;
  hasOnlyCrossCurrencySelection: boolean;
}

export const WireTransfersUKCallouts = ({
  hasCrossCurrencySelection,
  canApprove,
  hasOnlyCrossCurrencySelection,
}: WireTransfersUKCalloutsProps) => {
  const { t } = useTranslation('global');

  return (
    <>
      {hasCrossCurrencySelection && canApprove ? (
        <Callout
          title={t(
            'submitMyInvoice.scheduled.wireTransfer.immediateExecutionWarning',
          )}
          variant="warning"
        />
      ) : null}

      {!hasOnlyCrossCurrencySelection ? (
        <Callout
          title={t(
            'submitMyInvoice.scheduled.wireTransfer.ukTransfersSchedulingWarning',
          )}
          variant="warning"
        />
      ) : null}
    </>
  );
};
